import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import { Grid, MenuItem, Typography } from "@mui/material";
import SelectElement from "../../ReactHookFormElements/SelectElement";
import { FormContainer } from "react-hook-form-mui";
import ButtonLoading from "../../Button/ButtonLoading";
import { useForm } from "react-hook-form";
import { UseForm } from "../../../types/UseForm";
import { useState } from "react";
import { apiPatch } from "../../../services/Api/apiCall";
import { useSnackbar } from "notistack";
import { convertBooleanToYesNoString } from "../../../services/formServiceFunctions";
import { requiredFieldDefaultFieldBased } from "../../../services/reactHookFormValidationRules";
import { ProductUnion } from "../../../types/ProductUnion";

type StatusCheckModalProps = {
  product: ProductUnion;
  open: boolean;
  handleClose: Function;
};

export default function StatusCheckModal({ product, open, handleClose }: StatusCheckModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    shouldCheckCaseActivity:
      product.backofficeCase.shouldCheckCaseActivity !== null
        ? convertBooleanToYesNoString(product.backofficeCase.shouldCheckCaseActivity)
        : "",
    checkCaseActivityIntervalInMonths: product.backofficeCase.checkCaseActivityIntervalInMonths ?? null,
  };

  const formContext = useForm({
    defaultValues: initialValues,
  });

  if (!product) {
    return null;
  }

  const handleSubmit = async (values: UseForm["values"]) => {
    setIsLoading(true);

    let snackbarMessage =
      values.shouldCheckCaseActivity === "yes" ? "Statuscheck aktiviert" : "Statuscheck deaktiviert";
    let snackbarVariant: "custom" | "error" = "custom";

    const mappedValues = {
      shouldCheckCaseActivity: values.shouldCheckCaseActivity === "yes",
      checkCaseActivityIntervalInMonths: values.checkCaseActivityIntervalInMonths,
    };

    try {
      await apiPatch("/backoffice_cases", product.backofficeCase.id, mappedValues);
    } catch (e) {
      snackbarMessage = "StatusCheck konnte nicht gespeichert werden";
      snackbarVariant = "error";
    }

    enqueueSnackbar(snackbarMessage, {
      variant: snackbarVariant,
      isNonInteractive: true,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
    });

    setIsLoading(false);
    handleClose();
  };

  return (
    <LegalbirdIoModal
      title={"Automatischer Statuscheck"}
      open={open}
      handleClose={handleClose}
      submitButton={
        <FormContainer formContext={formContext} onSuccess={handleSubmit}>
          <ButtonLoading variant={"contained"} color={"primary"} type={"submit"} isLoading={isLoading}>
            Speichern
          </ButtonLoading>
        </FormContainer>
      }
    >
      <FormContainer formContext={formContext} onSuccess={handleSubmit}>
        <Typography>
          Das System prüft automatisch, ob er der Fall aktiv in Bearbeitung durch die Anwältin/den Anwalt ist. Sollte
          erkannt werden, dass keine Bearbeitung stattgefunden hat und auch keine neue Aktivität geplant ist, wird
          automatisch eine Aktivität zur manuellen Prüfung gesetzt.
        </Typography>
        <Grid container spacing={2}>
          <Grid size={6}>
            <SelectElement label={"Statuscheck"} name={"shouldCheckCaseActivity"} validation={requiredFieldDefaultFieldBased}>
              <MenuItem value={"no"}>Inaktiv</MenuItem>
              <MenuItem value={"yes"}>Aktiv</MenuItem>
            </SelectElement>
          </Grid>
          <Grid size={6}>
            <SelectElement
              label={"Häufigkeit Statuscheck"}
              name={"checkCaseActivityIntervalInMonths"}
              validation={requiredFieldDefaultFieldBased}
            >
              <MenuItem value={1}>Monatlich</MenuItem>
              <MenuItem value={2}>Alle 2 Monate</MenuItem>
              <MenuItem value={3}>Alle 3 Monate</MenuItem>
              <MenuItem value={4}>Alle 4 Monate</MenuItem>
              <MenuItem value={5}>Alle 5 Monate</MenuItem>
              <MenuItem value={6}>Alle 6 Monate</MenuItem>
            </SelectElement>
          </Grid>
        </Grid>
      </FormContainer>
    </LegalbirdIoModal>
  );
}
